import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconMapComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <path
        d="M9 6.75V15m6-6v8.25m.5 3.5 4.88-2.44c.38-.19.62-.58.62-1V4.81c0-.84-.88-1.38-1.63-1L15.5 5.74c-.31.16-.69.16-1 0l-5-2.5a1.13 1.13 0 0 0-1 0L3.62 5.7c-.38.19-.62.58-.62 1v12.49c0 .84.88 1.38 1.63 1l3.87-1.93c.31-.16.69-.16 1 0l5 2.5c.31.16.69.16 1 0z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </SvgIcon>
  );
};

IconMapComponent.displayName = 'IconMap';

const IconMap = memo(IconMapComponent);

export default IconMap;
